import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  leadFileList,
  resetLeadFilter,
  setContentList,
  setLeadFilter,
  setLeadList,
  setLeadName,
  setLeadTaskList,
} from "../../actions/actions";
import Header from "../../components/header";
import { deleteLeadList, getAllLeadList } from "../../services/leadListService";
import {
  copyLeadToLeadList,
  deleteLead,
  moveLeadToLeadList,
  uploadLeadFiles,
} from "../../services/leadService";
import { deleteLeadFile } from "../../services/leadService";
import CreateLeadForm from "./createLeadForm";
import LeadFilter from "./leadFilter";
import LeadsList from "./leadsList";
// import _ from "lodash";
import { ColDef } from "ag-grid-community";
import toast, { Toaster } from "react-hot-toast";
import { CSSProperties } from "styled-components";
import ConfirmationModal from "../../components/confirmationModal";
import CopyLeadToList from "../../components/copyLeadToList";
import CreateLeadDetailsTaskForm from "../../components/createLeadTaskForm";
import DrawerComponent from "../../components/drawer";
import DrawerExistModal from "../../components/drawerExistModal";
import SelectLeadLabel from "../../components/label";
import LeadDrawerComponent from "../../components/leadDrawer";
import MoveLeadToList from "../../components/moveLeadToList";
import SelectLeadStatus from "../../components/status";
import { API_URL } from "../../config/config";
import { activityById } from "../../services/activityService";
import { deleteTask, taskById } from "../../services/taskService";
import { uploadFiles } from "../../services/utilityService";
import ManageLeadsColumns from "./ManageColumns";
import AddEditList from "./addEditList";
import CustomLeadForm from "./customLeadForm";
import LeadDetails from "./leadDetails/leadDetails";
import LeadsGrid from "./leadsGrid/leads-grid";
import { FilterParams } from "./leadsGrid/leads.types";
import UploadCsvFile from "./uploadCsvFile";

import { FiFilter } from "react-icons/fi";
import LeadsNewFilter from "./leadsNewFilter";
import { Boxes, CheckSquare, ChevronDown, Repeat, Search, X } from "lucide-react";
import LeadsTour from "./LeadsTour";
import debounce from "lodash/debounce";
import logger, { Logger } from '../../utils/logger';
import { store } from "../../store/store";
import FilterStatusBar from "./FilterStatusBar";
import { getAllContent } from "../../services/contentService";


type ListMode = 'add' | 'edit';
const API_ENDPOINT = API_URL + "api/v1";


const leadsWrapperStyle: CSSProperties = {
  marginTop: 0,
  position: "relative",
  top: "2px", 
  height: "calc(100vh - 55px)", // Container height
  display: "flex",
  flexDirection: "column",
  // ADD THIS:
  overflow: "hidden" // Prevent parent scrolling
};
export interface LeadDataI {
  _id: string;
  name: string;
  integration: string;
  customSource: string;
  createdAt: Date;
  status: Array<string>;
  saleValue: string;
  website: string;
  phone: string;
  email: string;
  label: Array<any>;
}
export interface LeadItemI {
  _id: string;
  label: Array<any>;
  // Add other properties as needed
}

const Leads: React.FC = () => {
  
  const StoreData = useSelector((state: any) => {
    return state?.rootReducers;
  });

  logger.log("🏠 LEADS COMPONENT - Initial Mount:", {
  timestamp: new Date().toISOString(),
  component: 'leads.tsx',
  storeDataAvailable: !!StoreData,
  storeDataKeys: StoreData ? Object.keys(StoreData) : 'NULL'
});
const renderCount = useRef(0);

  const { leadCount } = useSelector((state: any) => state.rootReducers.leads);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [createNewLeadDrawer, showCreateNewLeadDrawer] =
    useState<boolean>(false);
  const [copyLeadToListModal, setShowCopyLeadToList] = useState<boolean>(false);
  const [moveLeadToListModal, setShowMoveLeadToList] = useState<boolean>(false);

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [openWithHeader, setOpenWithHeader] = React.useState<boolean>(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState<boolean>(false);
  const [showStatusPopup, setShowStatusPopup] = useState<boolean>(false);
  const [showLabelPopup, setShowLabelPopup] = useState<boolean>(false);
  const [selectedStatus, setSelectedStatus] = useState<string>("");
  const [leadToBeUpdate, setLeadToBeUpdate] = useState<string>("");
  const [selectedLabel, setSelectedLabel] = useState<Array<string>>([]);
  const [selectedLead, setSelectedLead] = useState<LeadDataI>();
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [leadListId, setLeadListId] = useState<string>("");
  const [from, setFrom] = useState<string>("");
  
  const [toBeRemoved, setToBeRemoved] = useState<string>("");
  const [updateModalValue, setUpdateModalValue] = useState<any>({});
  const [activityformTitle, setActivityFormTitle] = useState<string>("Add");
  const [activityformName, setActivityFormName] = useState<string>("");
  const [leadLabelData, setLeadLabelData] = useState<Array<string>>(
    StoreData?.user?.userPreferences?.labels ?? []
  );
  const [leadListData, setLeadListData] = useState<Array<any>>([]);
  const [taskShowConfirmationModal, setTaskShowConfirmationModal] =
    useState<boolean>(false);
  const [taskDeteleId, setTaskDeleteId] = useState<string>("");
  const [leadId, setLeadId] = useState<any>();
  const [showExitModal, setShowExitModal] = useState<boolean>(false);
  const [selectedLeadList, setSelectedLeadList] = useState<any>({});
  const [leadListObj, setLeadListObj] = useState<Array<string>>([]);
  const [leadFileObj, setLeadFileObj] = useState<any>({});
  const leadsGridRef = useRef<any>(null);
  const [searchValue, setSearchValue] = useState<string>("");
  const { filterParam }: { filterParam: FilterParams } = useSelector(
    (state: any) => state.rootReducers.leads
  );
  const searchDropdownRef = useRef<HTMLDivElement>(null);

const [isSearchingAllLists, setIsSearchingAllLists] = useState(false);
const [labelEditLead, setLabelEditLead] = useState<any>(null);
  const [initialFilterSection, setInitialFilterSection] = useState<string | undefined>(undefined);


 // Add these refs after your existing useState declarations
const isInitialMount = useRef(true);
const filterParamRef = useRef(filterParam);
const prevSelectedListRef = useRef(selectedLeadList?.id);
  const renderCountRef = useRef(0);

const [isListModalOpen, setListModalOpen] = useState(false);
const [selectedListId, setSelectedListId] = useState<string | undefined>(undefined);
const [modalMode, setModalMode] = useState<ListMode>('add');

  const [showFileDeleteModal, setShowFileDeleteModal] =
    useState<boolean>(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isBulk, setIsBulk] = useState<boolean>(false);
const [showListDropdown, setShowListDropdown] = useState(false);
  // ✅ Initialize with empty object, never undefined
  const [columnFilters, setColumnFilters] = useState<{[colId: string]: any}>(() => ({}));
  const dispatch = useDispatch();

  // let userPreferences = JSON.parse(
  //   localStorage.getItem("user_preferences") || ""
  // );

  let userPreferences: any = {};

  try {
    userPreferences = JSON.parse(
      localStorage.getItem("user_preferences") || ""
    );
  } catch (e) {
    userPreferences = {};
  }

 useEffect(() => {
  if (!StoreData?.leadList?.leadList?.length) {
    getLeadList(); // You already have this function!
  }
}, []);
  
useEffect(() => {
  if (!StoreData?.whatsapp?.content?.contentList?.length) {
    loadContentData();
  }
}, []);
  useEffect(() => {
    setLeadLabelData(StoreData?.user?.userPreferences?.labels ?? []);
  }, [StoreData?.user?.userPreferences?.labels]);
  
  const hasKey = userPreferences?.hasOwnProperty("custom_form") || false;


  const handleLeadUpdate = (updatedLead: LeadDataI) => {
    Logger.log('Lead Update Handler:', {
      updatedLead,
      currentSelectedLead: selectedLead,
      hasGridRef: !!leadsGridRef.current
    });
  
    // Update selected lead
    setSelectedLead(prevLead => {
      Logger.log('Updating Selected Lead:', {
        previous: prevLead,
        new: updatedLead
      });
      if (prevLead?._id === updatedLead._id) {
        return updatedLead;
      }
      return prevLead;
    });
    
    // Update grid if available
    if (leadsGridRef.current) {
      Logger.log('Updating Grid Data');
      leadsGridRef.current.refreshCurrentPageInGridFn([updatedLead]);
    } else {
      Logger.warn('Grid ref not available');
    }
  };

  useEffect(() => {
    
    
    // Only trigger when list ID actually changes
    if (selectedLeadList?.id !== prevSelectedListRef.current) {
      prevSelectedListRef.current = selectedLeadList?.id;
      
      logger.log('📋 Lead list changed to:', selectedLeadList?.id);
      
          setIsSearchingAllLists(false);


      // Get fresh state directly from Redux to avoid stale data
      const currentReduxState = store.getState();
      const currentFilterParam = currentReduxState.rootReducers.leads.filterParam;
      
      logger.log('Current Redux filter state:', currentFilterParam);
      
      // Update filter to include the new list ID
      const updatedFilter = {
        ...currentFilterParam,
        list: selectedLeadList?.id !== "0" ? selectedLeadList?.id : undefined,
        paginationParams: { page: 1, perPage: 50 }
      };
      
      logger.log('Dispatching updated filter:', updatedFilter);
      dispatch(setLeadFilter(updatedFilter));
      
      logger.log('✅ List filter dispatched - effect will handle fetch');
      
      // Update the lead name in Redux as well
      dispatch(setLeadName({
        id: selectedLeadList.id,
        name: selectedLeadList.name
      }));
      logger.log('✅ Updated lead name in Redux:', selectedLeadList.name);
    } else {
      logger.log('⏭️ No change in list ID - skipping');
    }
    
    
  // Still keep only necessary dependencies
  }, [selectedLeadList?.id, selectedLeadList?.name, dispatch]);

  useEffect(() => {
    // Check if we have a search term in filter params on initial load
    if (filterParam.search) {
      logger.log('Restoring search value from filterParam:', filterParam.search);
      setSearchValue(filterParam.search);
    }
  }, []); // Empty dependency array means this runs only once on mount

  // Click outside handler for dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchDropdownRef.current && !searchDropdownRef.current.contains(event.target as Node)) {
        setShowListDropdown(false);
      }
    };

    if (showListDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showListDropdown]);

 useEffect(() => {
  renderCountRef.current += 1;
  logger.log(`🏠 LEADS RENDER #${renderCountRef.current} - Component re-rendered`);

  // 🔍 Log what might be causing re-renders
  logger.log('📊 Current State Values:', {
    selectedLead: selectedLead ? 'SELECTED' : 'none',
    leadsCount: 'check your leads array variable name',
    filtersApplied: 'check your filters object',
    timestamp: new Date().toLocaleTimeString()
  });

  // 🚨 If renders > 5, something is wrong!
  if (renderCountRef.current > 5) {
    console.error('🔥 RENDER LOOP DETECTED! Check for inline objects/functions in JSX');
  }
});

// ✅ NEW: Sync column filters from grid to component state
useEffect(() => {
  try {
    if (leadsGridRef?.current?.getColumnFilters) {
      const filters = leadsGridRef.current.getColumnFilters();
      // Ensure filters is an object and not null/undefined
      if (filters && typeof filters === 'object' && !Array.isArray(filters)) {
        setColumnFilters(filters);
        logger.log('✅ Synced column filters from grid:', Object.keys(filters));
      } else if (!filters) {
        // If no filters, reset to empty object
        setColumnFilters({});
      }
    }
  } catch (error) {
    logger.error('Error syncing column filters:', error);
    setColumnFilters({});
  }
}, [filterParam]); // Re-sync whenever filterParam changes (indicates filter action)

  // Add this new effect after your existing effects
useEffect(() => {


  // Track changes to filterParam
  filterParamRef.current = filterParam;

  logger.log('Filter param:', filterParam);
  logger.log('Is initial mount:', isInitialMount.current);

  // Skip the first render to prevent fetch during initial mount
  if (!isInitialMount.current) {
    logger.log('🔄 Filter param changed - fetching data');
    logger.log('Filter state:', JSON.stringify(filterParam, null, 2));

    // ✅ FIX: Add setTimeout to let Redux update propagate through React's render cycle
    // This prevents the race condition where fetchLeadListOnScroll reads stale Redux state
    setTimeout(() => {
      // This is now the ONLY place where fetchLeadsWrapper is called directly
      if (leadsGridRef.current?.fetchLeadsWrapper) {
        leadsGridRef.current.fetchLeadsWrapper(true);
      } else {
        console.warn('Grid ref not available');
      }
    }, 0);
  } else {
    logger.log('⏭️ Skipping initial mount fetch');
    isInitialMount.current = false;
  }


}, [filterParam]); // Only depend on filterParam

  const onAddList = (mode: string) => {
    setModalMode(mode as ListMode);
    setSelectedListId(undefined);
    setListModalOpen(true);
  };
  
  const onEditList = (mode: string, id: string) => {
    setModalMode(mode as ListMode);
    setSelectedListId(id);
    setListModalOpen(true);
  };


 // REPLACE debouncedSearch:
const debouncedSearch = useCallback(
  debounce((searchValue: string) => {

    
    // ONLY dispatch to Redux when actually searching
    dispatch(setLeadFilter({
      ...filterParam,
      search: searchValue || undefined,
      isIgnoreList: isSearchingAllLists, // Include UI state here
      paginationParams: { page: 1, perPage: 50 }
    }));
    
    logger.log('✅ Search filter dispatched with isIgnoreList:', isSearchingAllLists);
    
  }, 500),
  [filterParam, isSearchingAllLists] // Add dependency
);
 
  



// UPDATE handleFilterChange to include UI state:
const handleFilterChange = (newFilterState: Partial<FilterParams>) => {
 
  // Include UI state when applying any filter
  debouncedFilterChange({
    ...filterParam,
    ...newFilterState,
    isIgnoreList: isSearchingAllLists, // Include UI state
    paginationParams: { page: 1, perPage: 50 }
  });
  
  
};

// AND ENSURE you have this debounced version:
const debouncedFilterChange = useCallback(
  debounce((filterState: Partial<FilterParams>) => {
   
    
    // CRITICAL FIX: Ensure mutual exclusivity
    // If we're setting teams, remove byOrganization
    if (filterState.teams && filterState.teams.length > 0) {
      delete filterState.byOrganization;
    }
    
    // If we're setting byOrganization, remove teams
    if (filterState.byOrganization === true) {
      delete filterState.teams;
    }
    
    // ONLY dispatch to Redux - no direct fetch call
    dispatch(setLeadFilter(filterState));
    
    logger.log('✅ Filter state dispatched to Redux - effect will handle fetch');
    
  }, 500),
  [] // Empty dependency array for stable debounce function
);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
    setSearchValue(value);
    debouncedSearch(value);
    
  };
 
const clearSearch = () => {
 
  Logger.log('Clearing search value');
  setSearchValue("");
  setIsSearchingAllLists(false);
  dispatch(setLeadFilter({
    ...filterParam,
    search: undefined,
    isIgnoreList: undefined // ✅ Explicitly clear this
  }));
  
};

  const handleLeadNameChange = (id: any, name: string) => {
    let tempObj = {
      id: id,
      name: name,
    };
    dispatch(setLeadName(tempObj));
    setSelectedLeadList(tempObj);
    leadsGridRef.current && leadsGridRef.current.fetchLeadsWrapper();
  };

  const getLeadList = useCallback(async () => {
    try {
      const resp = await getAllLeadList({
        isAscending: false,
        page: 1,
        perPage: 100,
      });
      if (resp && resp.status) {
        dispatch(setLeadList(resp?.data?.data));
      }
    } catch (err) {}
  }, [dispatch]);

  const onLeadClick = (rowData: any) => {
   
    
    // Keep defensive checks
    if (!rowData || !rowData._id) {
      Logger.warn('Invalid lead data received', rowData);
      
      return;
    }

    // 1. First open drawer with minimal data
    setOpenWithHeader(true);
    setLeadId(rowData?._id);
    setSelectedLead(rowData); // Keep full rowData to maintain existing behavior
    
    // 2. Process remaining data after drawer starts opening
    requestAnimationFrame(() => {
      // Keep your existing logic for labels
      let tempArray = StoreData?.user?.userPreferences?.labels
        ? StoreData?.user?.userPreferences?.labels
        : userPreferences?.labels;
    
      const updateArray = tempArray.map((obj: any) => ({
        ...obj,
        isLabelChecked: rowData?.label?.includes(obj.value) || false,
      }));

      if (rowData?.status) {
        setSelectedStatus(rowData?.status[0]);
      }
      setLeadLabelData(updateArray);
    });
    
    
};

  const toggleLeadFilterDrawer = () => {
    setShowFilterDrawer(true);
  };

  const handleDrawerClick = () => {
    setShowExitModal(!showExitModal);
    showCreateNewLeadDrawer(false);
  };
  const handleDrawerModalClose = () => {
    setShowExitModal(false);
    showCreateNewLeadDrawer(false);
  };
  const toggleEditModal = () => {
    setShowExitModal(!showExitModal);
  };

  const openCreateLeadDrawer = () => {
    showCreateNewLeadDrawer(true);
    setIsEditMode(false);
  };

  const editLead = (e: { stopPropagation: () => void }, id: any) => {
    e.stopPropagation();
    showCreateNewLeadDrawer(true);
    setOpenWithHeader(false);
    setIsEditMode(true);
    setLeadToBeUpdate(id);
  };

  const removeLead = (e: { stopPropagation: () => void }, id: any) => {
    e.stopPropagation();
    setLeadToBeUpdate(id);
    setShowConfirmationModal(true);
    setToBeRemoved("lead");
  };

  const deleteLeadFromDrawer = (id: string) => {
    setLeadToBeUpdate(id);
    setShowConfirmationModal(true);
    setToBeRemoved("lead");
    setOpenWithHeader(false);
  };

  const toggleModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };

  const onConfirmation = async () => {
    if (toBeRemoved === "lead") {
      try {
        const deleteResponse = await deleteLead(leadToBeUpdate);
        if (deleteResponse && deleteResponse.status) {
          toast.success(deleteResponse?.data?.message);
          refreshData();
        }
      } catch (err) {
        toast.error("Error while deleting the lead");
      }
    } else {
      try {
        const response = await deleteLeadList(leadListId);
        if (response && response.status) {
          toast.success(response?.data?.message);
          getLeadList();
        }
      } catch (err) {
        toast.error("error while deleting lead-list");
      }
    }
    setShowConfirmationModal(false);
  };

  const onDeleteClick = (id: string) => {
    setShowConfirmationModal(true);
    setToBeRemoved("leadlist");
    setLeadListId(id);
  };

  const copyLeadToList = () => {
    // setShowCopyLeadToList(!copyLeadToListModal);
  };

  const onCopy = async (id: string) => {
    let leadIds = [];
    leadIds.push(selectedLead?._id);
    try {
      const response = await copyLeadToLeadList({
        leadIDs: leadIds,
        listID: id,
      });
      if (response && response.status) {
        toast.success(response?.data?.message);
        copyLeadToList();
      }
    } catch (err) {
      toast.error("Error while copying lead to list");
      copyLeadToList();
    }
  };

  const moveLeadToList = () => {
    setShowMoveLeadToList(!moveLeadToListModal);
  };

  const onMove = async (id: string) => {
    let leads = [];
    leads.push(selectedLead?._id);
    try {
      const response = await moveLeadToLeadList({
        leadIDs: leads,
        toListID: id,
      });
      if (response && response.status) {
        toast.success(response?.data?.message);
        moveLeadToList();
      }
    } catch (err) {
      toast.error("Error while copying lead to list");
      moveLeadToList();
    }
  };

  const onSearch = async (search?: string) => {
    setShowFilterDrawer(false);
    debouncedSearch(search || '');
};

// ====================================
// REPLACEMENT for onLabelClick function in leads.tsx
// Problem: Missing setLabelEditLead() call that grid has
// ====================================

const onLabelClick = (data?: any) => {
 
  
  // If data is provided, use it, otherwise use selectedLead
  const leadData = data || selectedLead;
  
  if (!leadData) {
    console.error('❌ No lead data available for label editing');
    Logger.warn('No lead data available for label editing');
    
    return;
  }
  
  logger.log('📋 Using leadData:', {
    id: leadData._id,
    name: leadData.name,
    currentLabels: leadData.label
  });
  
  // ✅ CRITICAL FIX: Set labelEditLead just like the grid does
  setLabelEditLead(leadData);
  logger.log('✅ Set labelEditLead with data:', leadData._id);
  
  // Initialize leadLabelData with isLabelChecked flags
  const labelPreferences = StoreData?.user?.userPreferences?.labels || [];
  logger.log('Available label preferences:', labelPreferences.length);
  
  const labelArray = labelPreferences.map((labelObj: any) => ({
    ...labelObj,
    isLabelChecked: leadData?.label?.includes(labelObj.value) || false
  }));
  
  logger.log('Initialized label array:', {
    totalLabels: labelArray.length,
    checkedLabels: labelArray.filter((l: { isLabelChecked: any; }) => l.isLabelChecked).map((l: { name: any; }) => l.name)
  });
  
  // Set the leadLabelData with initialized isLabelChecked flags
  setLeadLabelData(labelArray);
  
  // Open the label popup
  setShowLabelPopup(true);
  logger.log('✅ Label popup opened');
  
};

  const toggleLeadLabel = () => {
    setShowLabelPopup(!showLabelPopup);
  };

  const onStatusClick = () => {
    setShowStatusPopup(true);
  };

  const toggleLeadStatus = () => {
    setShowStatusPopup(!showStatusPopup);
    setSelectedStatus("");
  };

  const onLabelChange = async (e: any, name?: string) => {
    if (!e?.target?.value) return;

    let Value = e.target.value;
    let newArray: any = [...selectedLabel];
    let labelArray: any = [...leadLabelData];
    let tempObj: any = {};
    tempObj = labelArray.find((x: any) => x.value === Value);
    if (tempObj?.isLabelChecked) {
      tempObj.isLabelChecked = false;
    } else {
      tempObj.isLabelChecked = true;
    }
    if (selectedLabel.includes(Value)) {
      let index = newArray.findIndex((d: string) => d === Value);
      newArray.splice(index, 1);
    } else {
      newArray = newArray.filter((d: string) => d !== Value);
      newArray.push(Value);
    }
    setLeadLabelData(labelArray);  // Remove the 'await' here as it's not needed
    setSelectedLabel(newArray);
  };

  const onStatusChange = (e: any) => {
    setSelectedStatus(e.target.value);
  };

  const handleEditActivityModal = async (
    name: string,
    _id: any,
    action: string
  ) => {
    if (name === "activity") {
      try {
        const response = await activityById(_id);
        if (response && response.status) {
          let modalId = "#AddNewActivites";
          handleActivityModal(action, "Activity");
          setUpdateModalValue(response.data.data);
          $(modalId).modal("show");
        }
      } catch (err) {
        toast.error("error while fetching activity data.");
      }
    }
    if (name === "task") {
      try {
        const response = await taskById(_id);
        if (response && response.status) {
          let modalId = "#AddNewTask";
          handleActivityModal(action, "Task");
          setUpdateModalValue(response.data.data);
          $(modalId).modal("show");
        }
      } catch (err) {
        toast.error("error while fetching activity data.");
      }
      let userPreferences = JSON.parse(
        localStorage.getItem("user_preferences") || ""
      );
    }
  };

  const handleActivityModal = (title: string, name: string) => {
    let modalId = "";
    if (name === "Activity") {
      modalId = "#AddNewActivites";
      setActivityFormTitle(title);
    } else {
      modalId = "#AddNewTask";
      setActivityFormTitle(title);
    }
    $(modalId).modal("show");
    setActivityFormName(name);
  };
  const taskToggleModal = () => {
    let modalId = "#AddNewTask";
    setActivityFormTitle("Edit");
    $(modalId).modal("show");
    setTaskShowConfirmationModal(!taskShowConfirmationModal);
  };

  const onTaskDelete = (id: string) => {
    let modalId = "#AddNewTask";
    setActivityFormTitle("Add");
    $(modalId).modal("hide");
    setTaskDeleteId(id);
    setTaskShowConfirmationModal(true);
  };
  const leadTaskDelete = async () => {
    try {
      const response = await deleteTask(taskDeteleId);
      if (response && response.status) {
        const tempArray = [...StoreData?.leadTask?.leadTask];
        const tempData = tempArray.findIndex((x) => x._id == taskDeteleId);
        tempArray.splice(tempData, 1);
        dispatch(setLeadTaskList(tempArray));
        toast.success(response?.data?.message);
      }
    } catch (err) {
      toast.error("Error while deleting task!");
    }
    setTaskShowConfirmationModal(false);
  };

  const onLeadFileUpload = async (e: any) => {
    Logger.log("FILE UPLOAD STARTING");
    let formData = new FormData();
    formData.append("files", e.target.files[0]);
    formData.append("type", "lead");
    formData.append("lead", leadId);
    
    try {
      Logger.log("CALLING UPLOAD LEAD FILES");
      const response = await uploadLeadFiles(formData);
      Logger.log("UPLOAD COMPLETE, RESPONSE:", response);
      
      if (response && response.status) {
        Logger.log("UPLOAD SUCCESS, CURRENT STORE:", StoreData?.leadFile?.leadFile);
        
        const tempArray = [...StoreData?.leadFile?.leadFile];
        // Access the data directly since we're structuring the response correctly in our service
        const newItem = response.data[0];
        
        if (newItem) {
          Logger.log("NEW ITEM TO ADD:", newItem);
          tempArray.unshift(newItem);
          Logger.log("ARRAY AFTER UNSHIFT:", tempArray.length);
          
          dispatch(leadFileList(tempArray));
          toast.success(response.message);
        } else {
          console.error("No file data in response");
          toast.error("Error processing uploaded file");
        }
      } else {
        toast.error(response.message || "Error uploading file");
      }
    } catch (err) {
      console.error("FILE UPLOAD ERROR:", err);
      toast.error("Error while uploading file!");
    }
  };

  const fileToggleModal = () => {
    setShowFileDeleteModal(!showFileDeleteModal);
  };
  
  const leadFileDeleteToggle = (objData: any) => {
    setLeadFileObj(objData);
    fileToggleModal();
  };

 const refreshData = () => {


  // ✅ Reset UI state
  setIsSearchingAllLists(false);
  setSearchValue("");
  logger.log('✅ Reset UI state - search and cross-list');

  // ✅ Clear column filters and sort
  if (leadsGridRef.current?.clearColumnFilters) {
    leadsGridRef.current.clearColumnFilters();
    logger.log('✅ Column filters cleared via grid ref');
  }

  // Capture current list state before reset
  const currentListId = StoreData?.leadName?.leadName?.id || "0";
  const currentListName = StoreData?.leadName?.leadName?.name || "Leads";

  // Reset Redux filters but preserve paginationParams for UX consistency
  dispatch(resetLeadFilter());

  // Re-apply the current list ID to maintain context if not default list
  if (currentListId !== "0") {
    dispatch(setLeadFilter({
      list: currentListId,
      paginationParams: { page: 1, perPage: 50 }
    }));

    // Ensure UI component state is in sync with Redux
    setSelectedLeadList({
      id: currentListId,
      name: currentListName
    });

    logger.log('✅ Preserved list during refresh:', {id: currentListId, name: currentListName});
  } else {
    // Reset UI component state to default as well
    setSelectedLeadList({
      id: "0",
      name: "Leads"
    });
    logger.log('✅ Reset to default list');
  }

  logger.log('✅ Filter reset with synchronized state');

};

  const leadFileDelete = async () => {
    // Check if selectedLead exists before proceeding
    if (!selectedLead?._id) {
      toast.error("Cannot delete file: No lead selected");
      return;
    }
  
    try {
      let objData = {
        type: "lead",
        lead: selectedLead._id, // Now we know this is defined
        filePaths: [leadFileObj.filePath],
      };
      const response = await deleteLeadFile(objData);
      if (response && response.status) {
        const tempArray = [...StoreData.leadFile.leadFile];
        const tempData = tempArray.findIndex(
          (x) => x.filePath == leadFileObj.filePath
        );
        tempArray.splice(tempData, 1);
        toast.success(response?.data?.message);
        dispatch(leadFileList(tempArray));
        setLeadFileObj({});
        fileToggleModal();
      }
    } catch (err) {
      toast.error("Error while deleting file.");
    }
  };

  const LeadFilterDataList = async (objectFilterData: Partial<FilterParams>) => {

    logger.log('Received filter data:', objectFilterData);
    
    // Forward to centralized handler
    handleFilterChange(objectFilterData);
    
    // Update any relevant local component state to stay in sync with Redux
    // For example, if the filter includes search:
    if (objectFilterData.search !== undefined) {
      setSearchValue(objectFilterData.search);
    }
    
    // Close drawer after applying filter
    setShowFilterDrawer(false);
    
    
  };
  

  const handleGetLeadList = async () => {
    try {
      const response = await getAllLeadList({
        isAscending: false,
        page: 1,
        perPage: 100,
      });
      if (response && response.status) {
        setLeadListObj(response.data.data);
      }
    } catch (err) {
      Logger.log(err, "Error");
    }
  };





// ADD function
const loadContentData = async () => {
  try {
    const response = await getAllContent({
      isAscending: false,
      page: 1,
      perPage: 500,
    });
    if (response?.status) {
      dispatch(setContentList(response.data.data));
    }
  } catch (err) {
    Logger.log(err, "Error loading content");
  }
};

  const setStatus = (e: string[]) => {
    // const updatedData: LeadDataI = { ...selectedLead, status: e };
    // Logger.log('selectedStatus', e, selectedLead);
    // setSelectedLead(updatedData);
  };

  const updateEditedRow = (updatedRows: any[]) => {
    let rows = Array.isArray(updatedRows)
      ? updatedRows
      : typeof updatedRows === "object"
      ? [updatedRows]
      : [];

    if (rows && rows.length > 0) {
      leadsGridRef.current &&
        leadsGridRef.current.refreshCurrentPageInGridFn(rows);

      if (leadsGridRef.current?.getSelectedLeadIds()?.length) {
        leadsGridRef.current?.fetchLeadsWrapper();
      }
    }
  };

  useEffect(() => {
    let lead_name = StoreData.leadName.leadName;
    if (!("id" in lead_name)) {
      dispatch(setLeadName({ id: "0", name: "Lead list" }));
    }
    lead_name = StoreData.leadName.leadName;
    setSelectedLeadList(
      Object.keys(lead_name).length > 0
        ? lead_name
        : { id: "0", name: "Lead list" }
    );
    handleGetLeadList();
  }, []);

  useEffect(() => {
    if (
      !showConfirmationModal &&
      !showFilterDrawer &&
      !showExitModal &&
      !showLabelPopup &&
      !showStatusPopup
    ) {
      document.body.style.overflow = "auto";
    }
  }, [
    showConfirmationModal,
    showFilterDrawer,
    showExitModal,
    showLabelPopup,
    showStatusPopup,
  ]);

  const [selectedItemCount, setSelectedItemCount] = useState<number>(0);


  renderCount.current++;
logger.log('🏠 LEADS - COMPONENT RENDER:', {
  timestamp: new Date().toISOString(),
  renderNumber: renderCount.current,
  showFilterDrawer,
  selectedLeadList: selectedLeadList?.id
});

  return (
    
    <div style={leadsWrapperStyle}>
      <LeadsTour />

      <Header
        onSearch={(e: any) => onSearch(e.target.value)}
        closeIconClick={() => onSearch()}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        
      />
      <div id="main" className="main" style={leadsWrapperStyle}>
        {!isBulk && selectedItemCount === 0 ? (
          <section className="leads-section-1">
            <div className="d-flex justify-content-between leads-section-1-1">
              <div className="align-items-center leads-section-1-sub-1">
              <div className="d-flex align-items-center">
  <button 
    onClick={toggleLeadFilterDrawer}
    id="filter-img"
    className="d-flex align-items-center justify-content-center gap-1 py-2 px-3"
    style={{
      backgroundColor: "#f1f5f9",
      borderRadius: "6px",
      border: "1px solid #e2e8f0",
      height: "36px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#334155",
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      cursor: "pointer",
      transition: "background-color 0.2s"
    }}
    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e2e8f0"}
    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f1f5f9"}
  >
    <FiFilter size={16} />
    <span>Filters</span>
  </button>
</div>
                <LeadsList
                  onDeleteClick={onDeleteClick}
                  leadLists={StoreData.leadList.leadList}
                  getLeadList={getLeadList}
                  onEditList={onEditList}
                  onAddList={onAddList}
                  leadData={leadCount}
                  LeadNameChange={handleLeadNameChange}
                  selectedLeadList={selectedLeadList}
                />
              </div>

             
     <div 
  ref={searchDropdownRef}
  className="flex-grow-1 mx-3" 
  style={{
    maxWidth: "500px",
    position: "relative",
    height: "36px",
  }}
>
  <div className="position-relative h-100">
    <div 
      className="position-absolute d-flex align-items-center" 
      style={{ 
        left: "16px",
        height: "100%",
        pointerEvents: "none"
      }}
    >
      <Search size={16} className="text-gray-400" />  
    </div>
    
    <input
      type="text"
      className="form-control h-100"
      placeholder="Search leads by name, email or phone..."
      value={searchValue}
      onChange={handleSearch}
      onFocus={() => setShowListDropdown(true)}
      style={{
        height: "100%",
        paddingLeft: "44px",
        paddingRight: searchValue ? (isSearchingAllLists ? "120px" : "44px") : (isSearchingAllLists ? "80px" : "32px"),
        backgroundColor: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: "400",
        color: "#334155",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
        transition: "all 0.2s ease",
      }}
    />
    
    {/* Cross-List Search Chip - Show when active */}
    {isSearchingAllLists && (
      <div
        className="position-absolute d-flex align-items-center"
        style={{
          right: searchValue ? "44px" : "12px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            logger.log("🔍 CROSS-LIST CHIP X CLICKED - Turning OFF");
            logger.log("🔍 Current search value:", searchValue);
            
            setIsSearchingAllLists(false);
            setShowListDropdown(false);
            
            // If there's a search term, re-run search with single list
            if (searchValue && searchValue.trim()) {
              logger.log("🔍 Re-running search for single list");
              debouncedSearch(searchValue);
            }
            
            logger.log("🔍 Cross-list search disabled");
          }}
          style={{
            fontSize: '11px',
            fontWeight: '500',
            color: '#fff',
            backgroundColor: '#28a745',
            border: 'none',
            padding: '2px 6px',
            borderRadius: '10px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            maxWidth: '60px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title="Currently searching across all lists - Click to return to current list"
        >
          🔍 All 
        </button>
      </div>
    )}
    
    {searchValue && (
      <button
        className="position-absolute d-flex align-items-center justify-content-center"
        onClick={clearSearch}
        style={{
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          width: "20px",
          height: "20px",
          border: "none",
          borderRadius: "50%",
          backgroundColor: "#e5e7eb",
          cursor: "pointer",
          padding: 0,
          transition: "all 0.2s ease",
          zIndex: 3
        }}
      >
        <X size={14} className="text-gray-600" />
      </button>
    )}
  </div>
  
  {/* Dropdown - ONLY show when NOT searching all lists */}
  {showListDropdown && !isSearchingAllLists && (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        backgroundColor: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "6px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 1000,
        marginTop: "4px",
        maxHeight: "200px",
        overflowY: "auto"
      }}
    >
      {/* Cross-List Search Toggle */}
      <div
        onClick={(e) => {
          e.stopPropagation();
          logger.log("🔍 CROSS-LIST TOGGLE CLICKED - Pure UI state");
          logger.log("🔍 Current search value:", searchValue);
          logger.log("🔍 Search value trimmed:", searchValue?.trim());
          
          setIsSearchingAllLists(true);
          setShowListDropdown(false);
          
          // If there's already a search term, run query immediately
        if (searchValue && searchValue.trim()) {
  logger.log("🔍 Search term exists - running cross-list query immediately");
  dispatch(setLeadFilter({
    ...filterParam,
    search: searchValue,
    isIgnoreList: true
  }));
} else {
  logger.log("🔍 No search term - just enabled cross-list mode");
}
          
          logger.log("🔍 Cross-list search enabled");
        }}
        style={{
          padding: "8px 12px",
          cursor: "pointer",
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontSize: "14px",
          borderRadius: "4px",
          margin: "4px"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#f8f9fa";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        <span>🔍</span>
        <span>Search across all lists</span>
      </div>
      
      {/* Info text */}
      <div style={{
        padding: "8px 12px",
        fontSize: "12px",
        color: "#6c757d",
        borderTop: "1px solid #f1f5f9"
      }}>
        Currently searching in: {selectedLeadList?.name || 'Current list'}
      </div>
    </div>
  )}
</div>

<div className="d-flex align-items-center gap-2">
  {/* Bulk actions button */}
  <button 
    onClick={() => setIsBulk(true)}
    className="d-flex align-items-center justify-content-center gap-2 py-2 px-3"
    style={{
      backgroundColor: "#f1f5f9",
      borderRadius: "6px",
      border: "1px solid #e2e8f0",
      height: "36px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#334155",
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      cursor: "pointer",
      transition: "background-color 0.2s"
    }}
    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e2e8f0"}
    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f1f5f9"}
    data-tour="bulk-actions"  
    title="Manage Leads in Bulk"
    aria-label="Manage Leads in Bulk"
  >
    <CheckSquare size={16} />
    <span>Bulk actions</span>
  </button>

  {/* Refresh button */}
  <button
    onClick={() => refreshData()}
    className="d-flex align-items-center justify-content-center gap-2 py-2 px-3"
    style={{
      backgroundColor: "#f1f5f9",
      borderRadius: "6px",
      border: "1px solid #e2e8f0",
      height: "36px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#334155",
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      cursor: "pointer",
      transition: "background-color 0.2s"
    }}
    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e2e8f0"}
    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f1f5f9"}
    title="Refresh"
    data-tour="refresh" 
    aria-label="Refresh"
  >
    <Repeat size={16} />
    <span>Refresh</span>
  </button>

  <ManageLeadsColumns
  defaultColumns={leadsGridRef.current
    ?.getColunmmnDefs()
    ?.map((c: ColDef) => {
      // Add logging to see what's being passed to the component
    
      return {
        label: c.headerName || '',
        value: c.colId || '',
      };
    }) || []
  }
  readOnlyColumns={[
    "name",
    "phone",
    "integration", // This is your "Source" column
    "status",
    "label",
    "lastActivityLabel", // Make sure this matches the ID in columnRegistry

  ]}
/>
                <div className="dropdown ms-1" style={{ position: "relative", zIndex: 10 }}>
                  <button
                    className="dropdown-toggle d-flex align-items-center justify-content-center gap-2 py-2 px-3"
                    type="button"
                    id="dropdownMenuButton2"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      backgroundColor: "#f1f5f9",
                      borderRadius: "6px",
                      border: "1px solid #e2e8f0",
                      height: "36px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#334155",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      cursor: "pointer !important",
                      transition: "background-color 0.2s",
                      position: "relative",
                      zIndex: 2,
                      display: "flex !important",
                      alignItems: "center !important",
                      justifyContent: "center !important",
                      outline: "none"
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#e2e8f0";
                      e.currentTarget.style.cursor = "pointer";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "#f1f5f9";
                      e.currentTarget.style.cursor = "pointer";
                    }}
                    title="Add new leads"
                    aria-label="Add new leads"
                  >
                    <span style={{ pointerEvents: "none", userSelect: "none" }}>Add new leads</span>
                    
                  </button>
                  <ul
                    className="leads_dropdown new_lead dropdown-menu pt-0 pb-0"
                    aria-labelledby="dropdownMenuButton2"
                    id="lists-dropdown"
                  >
                    <li
                      className="dropdown-item"
                      onClick={openCreateLeadDrawer}
                    >
                      Add/Import leads
                    </li>
                    <li
                      className="dropdown-item active"
                      onClick={openCreateLeadDrawer}
                    >
                      <svg
                        width="18"
                        height="20"
                        viewBox="0 0 18 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 3H15L13.5 5L12 3ZM2 0H16C17.11 0 18 0.9 18 2V18C18 19.11 17.11 20 16 20H2C0.9 20 0 19.11 0 18V2C0 0.9 0.9 0 2 0ZM2 2V6H16V2H2ZM2 18H16V8H2V18ZM4 10H14V12H4V10ZM4 14H14V16H4V14Z"
                          fill="black"
                        />
                      </svg>
                      Leadform
                    </li>
                   
                    <UploadCsvFile selectedList={selectedLeadList} />
                  </ul>
                </div>
              </div>
            </div>
          </section>
        ) : null}

{!isBulk && selectedItemCount === 0 ? (
  <>
    <LeadsNewFilter onFilterChange={handleFilterChange} />
    <FilterStatusBar
      onEditFilter={(section) => {
        logger.log(`Opening filter drawer with section: ${section}`);
        setInitialFilterSection(section);
        setShowFilterDrawer(true);
      }}
      columnFilters={columnFilters}
      onRemoveColumnFilter={(colId) => {
        logger.log('🗑️ Removing column filter for:', colId);
        // Call handleColumnFilterApply with null to clear the filter
        leadsGridRef.current?.handleColumnFilterApply?.(colId, null);
        // Update local state to reflect the removal
        setColumnFilters(prev => {
          const updated = { ...prev };
          delete updated[colId];
          logger.log('✅ Column filter removed from local state');
          return updated;
        });
      }}
    />
  </>
) : null}


<div data-tour="leads-grid" style={{ flex: 1, minHeight: 0 }}>
<LeadsGrid
  ref={leadsGridRef}
  leadListData={leadListData}
  setLeadListData={setLeadListData}
  handleLeadClick={onLeadClick}
  onEditStatus={() => setShowStatusPopup(true)}
  onEditLabel={(data) => {
    logger.log('📥 onEditLabel called with data:', data?._id || 'BULK_MODE');

    // Store the lead data for use in the modal
    setLabelEditLead(data);

    // Initialize leadLabelData with isLabelChecked flags
    const labelPreferences = StoreData?.user?.userPreferences?.labels || [];

    if (data) {
      // Single lead edit mode - check existing labels
      const labelArray = labelPreferences.map((labelObj: any) => ({
        ...labelObj,
        isLabelChecked: data?.label?.includes(labelObj.value) || false
      }));

      logger.log('Single lead label editing:', {
        leadId: data._id,
        existingLabels: data.label,
        labelArray: labelArray
      });

      setLeadLabelData(labelArray);
    } else {
      // Bulk edit mode - start with no labels selected
      const labelArray = labelPreferences.map((labelObj: any) => ({
        ...labelObj,
        isLabelChecked: false // No labels pre-selected for bulk operations
      }));

      logger.log('Bulk label editing mode - no pre-selected labels');
      setLeadLabelData(labelArray);
    }

    // Open the label popup
    setShowLabelPopup(true);
  }}
  setSelectedItemCount={setSelectedItemCount}
  selectedItemCount={selectedItemCount}
  showBulk={isBulk}
  onResetBulk={() => setIsBulk(false)}
  StoreData={StoreData}
/>
</div>

<LeadFilter
          isOpen={showFilterDrawer} // Pass the drawer state here
          onClose={() => setShowFilterDrawer(false)} // Set how to close it
          initialActiveSection={initialFilterSection}
           
 
          setShowFilterDrawer={setShowFilterDrawer}
          LeadFilterDataList={LeadFilterDataList} onLabelClick={function (): void {
            throw new Error("Function not implemented.");
          } } onStatusClick={function (): void {
            throw new Error("Function not implemented.");
          } } selectedStatus={""} selectedLabel={[]}/>

        <AddEditList
  mode={modalMode}

  id={selectedListId}
  getLeadList={getLeadList}
  onClose={() => setListModalOpen(false)}
  isOpen={isListModalOpen}
/>
        <LeadDrawerComponent
          openWithHeader={createNewLeadDrawer}
          setOpenWithHeader={toggleEditModal}
          drawerTitle={!isEditMode ? "Add New lead" : "Update lead"}
          size="sm"
        >
          {hasKey ? (
            <CustomLeadForm isEditMode={isEditMode} />
          ) : (
            <CreateLeadForm
              isDetailsBox={false}
              isEditMode={isEditMode}
              showCreateNewLeadDrawer={showCreateNewLeadDrawer}
              getLeads={refreshData}
              leadToBeUpdate={leadToBeUpdate}
              handleDrawerClick={handleDrawerModalClose}
              selectedLeadId={selectedLeadList.id}
              leadList={leadListObj}
            />
          )}
        </LeadDrawerComponent>

        {selectedLead && (
          <CreateLeadDetailsTaskForm
            leadIds={[{ id: selectedLead?._id }]}
            modalId="#AddNewTask"
            updateModalValue={updateModalValue}
            action={activityformTitle}
            formName={activityformName}
            onTaskDelete={onTaskDelete}
          />
        )}
        <div className="leadDetail_drawer">
          <DrawerComponent
            openWithHeader={openWithHeader}
            setOpenWithHeader={setOpenWithHeader}
            customHeader={false}
            drawerTitle="Lead Details"
            size="lg"
            className="lead_details"
          >
            <LeadDetails
              _id={selectedLead?._id || ""}
              name={selectedLead?.name || ""}
              integration={selectedLead?.integration || ""}
              customSource={selectedLead?.customSource || ""}
              createdAt={selectedLead?.createdAt || new Date()}
              status={selectedLead?.status || []}
              saleValue={selectedLead?.saleValue || ""}
              website={selectedLead?.website || ""}
              label={selectedLead?.label || []}
              leadListId={StoreData.leadName.leadName?.id}
              deleteLeadFromDrawer={deleteLeadFromDrawer}
              copyLeadToList={copyLeadToList}
              moveLeadToList={moveLeadToList}
              onLabelClick={onLabelClick}
              onStatusClick={onStatusClick}
              setFrom={setFrom}
              handleEditModal={handleEditActivityModal}
              handleLeadDetailsModalOpen={handleActivityModal}
              onLeadFileUpload={onLeadFileUpload}
              editLead={editLead}
              leadFileDelete={leadFileDeleteToggle}
              refreshData={refreshData}
              onDeleteLead={() => {
                leadsGridRef.current &&
                  leadsGridRef.current.fetchLeadsWrapper();
                setOpenWithHeader(false);
                {Logger.log('3. Drawer Render:', {
                  openWithHeader,
                  selectedLead,
                  hasLeadData: !!selectedLead
                })}
              }}
            />
          </DrawerComponent>
        </div>
        <ConfirmationModal
          onConfirmation={onConfirmation}
          showModal={showConfirmationModal}
          toggleModal={toggleModal}
          message={`Are you sure you want to delete this ${
            toBeRemoved === "lead" ? "lead" : "lead list"
          }`}
          title="Lead"
        />
        <ConfirmationModal
          onConfirmation={leadTaskDelete}
          showModal={taskShowConfirmationModal}
          toggleModal={taskToggleModal}
          message="Are you sure you want to delete this task?"
          title="Task"
        />
        <ConfirmationModal
          onConfirmation={leadFileDelete}
          showModal={showFileDeleteModal}
          toggleModal={fileToggleModal}
          message="Are you sure you want to delete this file?"
          title="File"
        />
        <CopyLeadToList
          copyLeadToListModal={copyLeadToListModal}
          copyLeadToList={copyLeadToList}
          leadList={StoreData.leadList.leadList}
          onCopy={onCopy}
        />
        <MoveLeadToList
          moveLeadToList={moveLeadToList}
          leadList={StoreData.leadList.leadList}
          moveLeadToListModal={moveLeadToListModal}
          onMove={onMove}
        />
        <SelectLeadLabel
          showLabelPopup={showLabelPopup}
          toggleLeadLabel={toggleLeadLabel}
          onLabelChange={onLabelChange}
          selectedLabel={selectedLabel}
          onLeadUpdate={handleLeadUpdate}
          setShowLabelPopup={setShowLabelPopup}
          from={from}
          id={
            leadsGridRef.current?.getSelectedLeadIds()?.length
              ? leadsGridRef.current?.getSelectedLeadIds()
              : labelEditLead?._id || ""
          }
          leadList={selectedLeadList.id}
          getLeads={refreshData}
          setOpenWithHeader={setOpenWithHeader}
          LabelData={leadLabelData}
          updateEditedRow={updateEditedRow}
          filterParams={filterParam}
          isFilterMode={leadsGridRef.current?.isFilterSelectionMode || false}
        />
        <SelectLeadStatus
          showStatusPopup={showStatusPopup}
          toggleLeadStatus={toggleLeadStatus}
          onStatusChange={onStatusChange}
          onLeadUpdate={handleLeadUpdate}
          selectedStatus={selectedStatus}
          setShowStatusPopup={setShowStatusPopup}
          from={from}
          id={
            leadsGridRef.current?.getSelectedLeadIds()?.length
              ? leadsGridRef.current?.getSelectedLeadIds()
              : selectedLead?._id || selectedLead?._id || ""
          }
          leadList={selectedLeadList.id}
          getLeads={refreshData}
          setOpenWithHeader={setOpenWithHeader}
          updateEditedRow={updateEditedRow}
          filterParams={filterParam}
          isFilterMode={leadsGridRef.current?.isFilterSelectionMode || false}
        />
        <DrawerExistModal
          title="Are you sure you want to exit ?"
          showExitModal={showExitModal}
          toggleEditModal={toggleEditModal}
          handleDrawerClick={handleDrawerClick}
        />
        <Toaster position="top-right" reverseOrder={false} />
      </div>
    </div>
 
  );
};

export default Leads;